import React from "react";
import Joi from "joi-browser";
import {Form} from "./form";
import { sendPaymentRequest } from "../../services/paymentService";
import { showProgressBar } from "../../services/uiService";
import { hideProgressBar } from "../../services/uiService";
import { createDNandRERequest } from "../../services/generalService";
import { getErrorMessages } from "../../services/uiService";
import { makePayment, initiatePayment } from "../../services/paymentService";
//import {MyPayment} from '../../components/mypayment';
import ShortValueField from "../fields/shortValueField";
import { BrowserView, MobileView } from "react-device-detect";
import "../../styles/paymentDetailsForm.css";
import DatePicker from "react-datepicker";
import * as Yup from "yup";
import CreditCardDatePicker from "./../fields/CreditCardDatePicker";

import PhoneInput from "react-phone-number-input/mobile";
import "react-phone-number-input/style.css";
import { throwError } from "rxjs";
import { ConfigContext } from "./../../context/ConfigContext";

import { connect } from 'react-redux';
import store from './../../../store';
import { selectConfig } from "./../../redux/slices/configSlice";
import { populateFromSearch, fetchIdTypeOptions, fetchUsersList, setSelectedType, setPaymentField, setPaymentRequestField, selectPayment, showError, returnFromError } from './../../redux/slices/paymentSlice';
import { selectLandSearch, setShow, setPrevStage, setNextStage, clearAllErrors, setErrorState } from './../../redux/slices/landSearchSlice';
import {sendClickLog, sendLog} from './../../services/paymentService';

class PaymentDetailsForm extends Form {
  static contextType = ConfigContext; 
  config = selectConfig(store.getState());
  moduleName = "LAND";
  checkoutReject = null;

  /*Before redux
  state = {
    data: {
      // PayerPhoneNumber: "",
      // PinCode: "",
      // BillingDetails:"",
      IDNumber: this.props.IDNumber,
      FirstName: this.props.FirstName,
      LastName: this.props.LastName,
      Email: this.props.Email,
      /*SecurityNumber:"",
      CardNumber: "",
      CardExpiryDate: "",//new Date(),
      CardType: "",*
      IDType: this.props.IDType,
      LandId: this.props.landid,
      feeValue: this.props.feeValue,
      paymentmethod: "Online",
      orderId: "",
      custRef:"0000",
      revenueCode: "60001001/12040687",
      fullName: "",
      merchant_code: "MX64729",
      splitAccounts: "",
      ReferenceNumber: ""
    },
    paramsData: [
                  { FieldName: "IDNumber", FieldType: "String" },
                  { FieldName: "FirstName", FieldType: "String" },
                  { FieldName: "LastName", FieldType: "String" },
                  { FieldName: "Email", FieldType: "String" },
                  *{ FieldName: "SecurityNumber", FieldType: "String" },
                  { FieldName: "CardNumber", FieldType: "String" },
                  { FieldName: "CardExpiryDate", FieldType: "String" },
                  { FieldName: "CardType", FieldType: "String" },*
                  { FieldName: "IDType", FieldType: "String" },
                  { FieldName: "LandId", FieldType: "Int" },
                  { FieldName: "feeValue", FieldType: "String" },
                  { FieldName: "paymentmethod", FieldType: "String" },
                  { FieldName: "ReferenceNumber", FieldType: "String" }],
    paymentRequest: {
      //For TEST
      /*merchant_code: "VNA",
      pay_item_id: "103",
      txn_ref: "",
      amount: 0,
      cust_id: "85221332236",
      currency: '566',
      site_redirect_url: 'https://google.com', //window.location.origin,
      onComplete: this.onReturnBack,
      mode: "TEST",
      split_accounts: ""*
      
      //For PROD
      merchant_code: "MX64729",
      pay_item_id: "Default_Payable_MX64729",
      txn_ref: "",
      amount: 0,
      cust_id: "85221332236",
      currency: '566',
      site_redirect_url: window.location.origin,
      onComplete: this.onReturnBack,
      mode: "LIVE",
      split_accounts: ""
    },
    selectedType: this.props.IDType,
    selectedMonth: '',
    selectedYear: '',
    PaymentCurrency: "EUR",
    WebUserId: this.props.WebUserId ? this.props.WebUserId : "0",
    OwnerId: this.props.OwnerId ? this.props.OwnerId : "0",
    PropertyNumber: this.props.propertyNumber,
    ModuleName: this.moduleName,
    errors: {},
    updateShowCase: this.props.updateShowCase,
    nextStage: this.props.nextStage,
    backToPrevStage: this.props.backToPrevStage,
    prevStage: this.props.prevStage,
    CardTypesOptions: [],
    IdTypesOptions: [],
    UsersList: []
  };
  */

  schema = {
    IDNumber: Joi.string()
    .required()
    .error((errors) => {
      errors.forEach((err) => {
        switch (err.type) {
          case "any.required":
            err.message = "ID number is required";
            break;
          case "any.empty":
            err.message = "Please enter ID number";
            break;
          case "string.regex.base":
            err.message = "Please enter ID number";
            break;
          default:
            break;
        }
      });
      return errors;
    })
    .label("ID number"),
    FirstName: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "any.required":
              err.message = "First Name is required";
              break;
            case "any.empty":
              err.message = "Please enter First Name";
              break;
            case "string.regex.base":
              err.message = "Please enter First Name";
              break;
            default:
              break;
          }
        });
        return errors;
      })
      .label("First Name"),
      LastName: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "any.required":
              err.message = "Last Name is required";
              break;
            case "any.empty":
              err.message = "Please enter Last Name";
              break;
            case "string.regex.base":
              err.message = "Please enter Last Name";
              break;
            default:
              break;
          }
        });
        return errors;
      }).label("LastName"),
      Email: Joi.string()
      .email({ tlds: { allow: false } }) 
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "string.email":
              err.message = "Invalid email format";
              break;
            default:
              break;
          }
        });
        return errors;
      }).label("Email"),

      IDType: Joi.string()
      .allow('')
      .default(' ')
      .label("IDType "),

      SecurityNumber: Joi.string()
      .required()
      .error((errors) => {
        errors.forEach((err) => {
          switch (err.type) {
            case "any.required":
              err.message = "Security Number is required";
              break;
            case "any.empty":
              err.message = "Please enter Security Number";
              break;
            case "string.regex.base":
              err.message = "Please enter Security Number";
              break;
            default:
              break;
          }
        });
        return errors;
      })
  };

  componentDidUpdate(prevProps) {
  // Track when paymentdata changes
  if (prevProps.paymentdata !== this.props.paymentdata) {
    console.log('paymentdata changed from:', prevProps.paymentdata, 'to:', this.props.paymentdata);
  }
}

  componentDidMount() {
 
  const backup = localStorage.getItem('paymentDataBackup');
  const returning = localStorage.getItem('returningFromError');

  if (backup && returning) {
    const data = JSON.parse(backup);
    // Restore each field
    Object.keys(data).forEach(key => {
      this.props.setPaymentField({ field: key, value: data[key] });
    });
    
    // Clear flags
    localStorage.removeItem('paymentDataBackup');
    localStorage.removeItem('returningFromError');
    return;
  }
  
 

 const {
      WebUserId,
      OwnerId,
      propertyNumber,
      ModuleName,
      populateFromSearch
    } = this.props; //props of landSearch

    populateFromSearch({
      WebUserId,
      OwnerId,
      PropertyNumber: propertyNumber,
      ModuleName
    }); //populate payment slice


    this.props.setShow("paymentDetails");
    this.props.setPrevStage("searchResults");
    this.props.setNextStage("paymentsConfirm");

    /* before redux
    fetch(this.context.generalEndPoint + "/IdTypeOptions")
      .then(response => response.json())
      .then(data => {
        this.setState({ IdTypesOptions: data });
        console.log(data)
      })
      .catch(error => {
        console.error('Error fetching options for ID types list:', error);
      });
      */

      // Get the list of ID types from the server
      this.props.fetchIdTypeOptions(this.config.generalEndPoint);

      //Get a list of all the users from the txt file
      this.props.fetchUsersList();

      
      /*before redux 
      fetch('https://onlineservices.mol.anambrastate.gov.ng/UsersPermissions.txt', {
        headers: {
          'X-Auth-Token': 'Sivan2024'
      }
      })
      .then(response => response.text())
      .then(text => {
        // Split the text into individual JSON objects
        const jsonObjects = text.split('},').map(obj => {
          // Add back the '}' that was removed by split
          if (obj.endsWith('}')) {
            return obj;
          }
          return obj  + '}';
        });

        // Parse each JSON object
        const userList = jsonObjects.map(jsonString => {
          try {
            return JSON.parse(jsonString);
          } catch (error) {
            console.error('Error parsing JSON:', error);
            return null;
          }
        }).filter(user => user !== null);

        // Set the parsed user list to the state
        this.setState({ UsersList: userList });
      })
      .catch(error => console.error('Error fetching text file:', error));
      */

      const script = document.createElement('script');
      script.src = 'https://newwebpay.interswitchng.com/inline-checkout.js';
      //script.src = 'https://newwebpay.qa.interswitchng.com/inline-checkout.js';  //For TEST
      script.async = true;
      document.head.appendChild(script);

  }

  backStage = () => {
    const { backToPrevStage, prevStage } = this.props;

    localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
    localStorage.setItem('returningFromError', 'true');

    this.props.backToPrevStage(prevStage);
  };

  checkPermissionUser = () => {
    const { paymentdata, UsersList } = this.props;

    //Check if one of the list items is equal to the actual user
    return this.props.UsersList.some(user =>
      paymentdata.FirstName.toLowerCase() === user.FirstName.toLowerCase() &&
      paymentdata.LastName.toLowerCase() === user.LastName.toLowerCase() &&
      paymentdata.IDNumber === user.IDNumber &&
      paymentdata.IDType === user.IDType
    );
  };

initiatePaymentfunction= async () => {
  console.log("Initiating payment");

  let { paymentdata } = this.props;
  const newData = { ...paymentdata };

  if(newData.fullName === '')
  {
    newData.fullName = paymentdata.FirstName + " " + paymentdata.LastName
  }

  console.log(
    "initiate payment: data.revenueCode: " +
      newData.revenueCode +
      ",data.amount: " +
      newData.feeValue * 100 +
      ",data.custRef: " +
      newData.custRef +
      ",data.fullName: " +
      newData.fullName
  );

  //try {

  const PaymentResponse = await initiatePayment(this.context.paymentEndPoint, newData);

  const makePaymentStatus = PaymentResponse.data["success"];
  const message = PaymentResponse.data["message"];

  if (makePaymentStatus) {
    console.log(message);

    const makePaymentResult = JSON.parse(PaymentResponse.data["paymentResult"]);
    console.log("Initiate Payment Result=", makePaymentResult);

    if (
      makePaymentResult !== undefined &&
      makePaymentResult.Data["OrderId"] !== undefined &&
      makePaymentResult.Data["SplitAccounts"] !== undefined
    ) {
      //this.props.updatePaymentResults(makePaymentResult);
      //this.props.updateShowCase(this.props.nextStage);
      /* before redux 
      data.splitAccounts = JSON.stringify(
        makePaymentResult.Data.SplitAccounts
      );
      data.orderId = makePaymentResult.Data.OrderId;
      this.setState({ data: data });
      */

      this.props.setPaymentField({ field:'splitAccounts', value:JSON.stringify(makePaymentResult.Data.SplitAccounts) });
      this.props.setPaymentField({ field:'orderId', value:makePaymentResult.Data.OrderId });
    } 
    else {
      if (message.includes("A connection attempt failed because the connected party did not properly respond after a period of time"))
      {
        throw "PAYMENT_DOWN";
      }

      throw "PAYMENT_FAILURE";

      // let msg = getErrorMessages("PAYMENT_FAILURE");
      // this.props.updateErrorMessage(
      // msg["Title"],
      // msg["Message"],
      // msg["LinkTo"],
      // msg["LinkTitle"],
      // msg["LinkClass"]
      // );

      // // this.props.updateBillingDetails(paymentdata.FirstName, paymentdata.LastName, paymentdata.Email, paymentdata.IDNumber, paymentdata.IDType);
      // sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, newData.fullName, 'Payment Failure');

      // this.props.updateShowCase(this.props.errorStage);
    }
  } else {
    if (message.includes("A connection attempt failed because the connected party did not properly respond after a period of time"))
    {
      throw "PAYMENT_DOWN";
    }
    else if(message.includes("The SSL connection could not be established"))
    {
      throw "PAYMENT_FAILURE";
    }

    throw "PAYMENT_CANCEL";
    // let msg = getErrorMessages("PAYMENT_CANCEL");

    // // let msg = getErrorMessages("PAYMENT_CANCEL");
    // this.props.updateErrorMessage(
    //   msg["Title"],
    //   msg["Message"],
    //   msg["LinkTo"],
    //   msg["LinkTitle"],
    //   msg["LinkClass"]
    // );
    // //before redux this.props.updateShowCase(this.props.errorStage);
    // if (this.props.paymentdata) {
    //   localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
    //   localStorage.setItem('returningFromError', 'true');
    // }
  
    // this.props.showError();
    // this.props.setShow(this.props.errorStage);
  }
  /*} catch (ex) {
      console.log("PAYMENT ERROR=", ex);
      if (ex.response && ex.response.status === 400) {
        let errors = { ...this.state.errors };
        errors.userName = ex.response.data;
        this.setState({ errors });
        console.log("payment ERROR=", errors);
      }
    }*/
  }

  onReturnBack = async (response) => {
    console.log("on return back, call CBS notification endpoint");
    console.log(response); //response from interswitch
    
    const { paymentdata } = this.props;
    const fullName = paymentdata.FirstName + " " + paymentdata.LastName

    if (response.cardNum='' || response.retRef===undefined)
    {
      if (this.checkoutReject) {
      this.checkoutReject(new Error("User cancelled the payment on return"));
      this.checkoutReject = null; // Prevent multiple calls
      }

      let msg = getErrorMessages("PAYMENT_CANCEL");
      this.props.updateErrorMessage(
        msg["Title"],
        msg["Message"],
        msg["LinkTo"],
        msg["LinkTitle"],
        msg["LinkClass"],
        msg["prevStage"]
      );
      //before redux this.props.updateShowCase(this.props.errorStage);
      if (this.props.paymentdata) {
        localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
        localStorage.setItem('returningFromError', 'true');
      }
    
      this.props.showError();
      this.props.setShow(this.props.errorStage);
    }
    else{
      //try {
      const PaymentResponse = await makePayment(this.context.paymentEndPoint, paymentdata);
      console.log(PaymentResponse);
      const makePaymentResult = JSON.parse(PaymentResponse.data["paymentResult"]);
      const makePaymentStatus = PaymentResponse.data["success"];
      const message = PaymentResponse.data["message"];

      console.log("Make Payment Response =", makePaymentStatus);
      console.log("Make Payment Result=", makePaymentResult);
      console.log("Make Payment message=", message);

    if (makePaymentStatus) {
      if (makePaymentResult !== undefined && makePaymentResult.Data["Message"]!== undefined) {
        this.props.updatePaymentResults(makePaymentResult);
        
        if (makePaymentResult.Data["Message"] === 'Success') {
          /* before redux
          data.ReferenceNumber = response.retRef;
          this.setState({data})
          */
          this.props.setPaymentField({ field:'ReferenceNumber', value:response.retRef });

          this.props.updateBillingDetails(paymentdata.FirstName, paymentdata.LastName, paymentdata.Email, paymentdata.IDNumber, paymentdata.IDType);
          sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'Payment successful');

          this.confirmData();
          hideProgressBar();
        }
        else
        {
          if (makePaymentResult.Data["Message"].includes("A connection attempt failed because the connected party did not properly respond after a period of time"))
          {
            throw "PAYMENT_DOWN";
          }

          throw "PAYMENT_FAILURE";

          // let msg = getErrorMessages("PAYMENT_FAILURE");

          // this.props.updateErrorMessage(
          // msg["Title"],
          // msg["Message"],
          // msg["LinkTo"],
          // msg["LinkTitle"],
          // msg["LinkClass"],
          // msg["prevStage"]
          // );
          
          // this.props.updateBillingDetails(paymentdata.FirstName, paymentdata.LastName, paymentdata.Email, paymentdata.IDNumber, paymentdata.IDType);
          // sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'Payment Failure');
          
          // //before redux this.props.updateShowCase(this.props.errorStage);
          // if (this.props.paymentdata) {
          //   localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
          //   localStorage.setItem('returningFromError', 'true');
          // }

          // this.props.showError();
          // this.props.setShow(this.props.errorStage);
          // hideProgressBar();
        }
        return makePaymentStatus;
      }
    } else {
      /*let msg = getErrorMessages("PAYMENT_FAILURE");
      console.log(msg);
      console.log(msg["Title"]);
      console.log(msg["Message"]);

      this.props.updateErrorMessage(
      msg["Title"],
      msg["Message"],
      msg["LinkTo"],
      msg["LinkTitle"],
      msg["LinkClass"]
      );
      this.props.updateShowCase(this.props.errorStage);*/
      this.props.updateBillingDetails(paymentdata.FirstName, paymentdata.LastName, paymentdata.Email, paymentdata.IDNumber, paymentdata.IDType);
      sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'No payment result');
      hideProgressBar();

      throw "PAYMENT_FAILURE";
    }
    /*} catch (ex) {
      console.log("PAYMENT ERROR=", ex);
      if (ex.response && ex.response.status === 400) {
        let errors = { ...this.state.errors };
        errors.userName = ex.response.data;
        this.setState({ errors });
        console.log("payment ERROR=", errors);
      }
    }*/
    }
}

emptySelectedValue = () => {
  /* before redux
  this.setState({
    selectedType: ""
  });
  */

  this.props.setSelectedType("");
}

  validateFields = () => {
    const { IDNumber, FirstName, LastName } = this.props.paymentdata;
    const { selectedType } = this.props;

    if (
      IDNumber === undefined ||
      selectedType === undefined ||
      FirstName === undefined ||
      LastName === undefined ||
      IDNumber === "" ||
      FirstName === "" ||
      LastName === "" ||
      selectedType === ""
    ) {
      throw "BillingDetailsMissingException";
    }
  }


executePayment = async() => {
  const {paymentdata, selectedType} = this.props
  const fullName = paymentdata.FirstName + " " + paymentdata.LastName
  sendClickLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName);

  this.props.setPaymentField({field:"fullName" , value:fullName})
  let allowUser = false;

  showProgressBar();

  try
  {
    this.validateFields();
    allowUser = this.checkPermissionUser();

    if (allowUser)
    {
      //this.confirmData();
      //before redux this.props.updateShowCase(this.props.nextStage);
      sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'SuperUser');
      this.props.setShow(this.props.nextStage);
    }
    else {
      const result = await this.callPaymentFunction();
      console.log(result);
    } 
  }
  catch (error)
  {
    const fullName = this.props.paymentdata.FirstName + " " + this.props.paymentdata.LastName

    
    if (error === "BillingDetailsMissingException")
    {
      let msg = getErrorMessages("BILLING_DETAILS_MISSING");

      this.props.setErrorState({
        errorTitle: msg["Title"],
        errorMessage: msg["Message"],
        errorLinkTo: msg["LinkTo"],
        errorLinkTitle: msg["LinkTitle"],
        errorLinkClassName: msg["LinkClass"],
        prevStage: msg["prevStage"],
      });
      if (this.props.paymentdata) {
        localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
        localStorage.setItem('returningFromError', 'true');
      }
  
      this.props.showError();
      this.props.setShow(this.props.errorStage);
    }
    else{
      if (allowUser)
      {
        //this.confirmData();
        //before redux this.props.updateShowCase(this.props.nextStage);
        this.props.setShow(this.props.nextStage);
      }
      else { 
        //PAYMENT_DOWN, PAYMENT_CANCEL, PAYMENT_FAILURE
        sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, error);
        let msg = getErrorMessages(error);

        this.props.setErrorState({
          errorTitle: msg["Title"],
          errorMessage: msg["Message"],
          errorLinkTo: msg["LinkTo"],
          errorLinkTitle: msg["LinkTitle"],
          errorLinkClassName: msg["LinkClass"],
          prevStage: msg["prevStage"],
        });
        if (this.props.paymentdata) {
          localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
          localStorage.setItem('returningFromError', 'true');
        }
    
        this.props.showError();
        this.props.setShow(this.props.errorStage);

      }
    }
    hideProgressBar();
  }
  hideProgressBar();
}


//For TEST payment function
callPaymentFunction_TEST= async () => {
  await this.initiatePaymentfunction();
  
  let { paymentdata } = this.props;

   var samplePaymentRequest = {
    amount: 2000000, 
    currency: 566, 
    merchant_code: 'VNA',
    pay_item_id: '103',
    txn_ref: paymentdata.orderId,
    site_redirect_url: 'https://google.com',
    mode: 'TEST',
    onComplete: this.onReturnBack,
  };

  //call webpayCheckout to initiate the payment
  const checkoutResult = await this.callCheckoutFunction(samplePaymentRequest);

  console.log(checkoutResult);
  return "Success"; 
}

//For PROD payment function
callPaymentFunction= async () => {
  const fullName = this.props.paymentdata.FirstName + " " + this.props.paymentdata.LastName

  await this.initiatePaymentfunction();

  let { paymentRequest, paymentdata } = this.props;
  /* before redux
  paymentRequest.txn_ref = data.orderId;
  paymentRequest.split_accounts = data.splitAccounts;
  paymentRequest.amount = data.feeValue * 100;
  paymentRequest.site_redirect_url = window.location.origin;
  paymentRequest.onComplete = this.onReturnBack;

  console.log(paymentRequest.amount);
  this.setState({ paymentRequest });
  */
  let newPaymentRequest = {...paymentRequest};
  newPaymentRequest.txn_ref = paymentdata.orderId;
  newPaymentRequest.split_accounts = paymentdata.splitAccounts;
  newPaymentRequest.amount = paymentdata.feeValue * 100;
  newPaymentRequest.site_redirect_url = window.location.origin;

  // Update Redux (only serializable values)
  Object.entries({
    txn_ref: newPaymentRequest.txn_ref,
    merchant_code: newPaymentRequest.merchant_code,
    split_accounts: newPaymentRequest.split_accounts,
    amount: newPaymentRequest.amount,
    site_redirect_url: newPaymentRequest.site_redirect_url,
    pay_item_id: newPaymentRequest.pay_item_id,
    currency: newPaymentRequest.currency,
    mode: newPaymentRequest.mode
  }).forEach(([field, value]) => {
    this.props.setPaymentRequestField({ field, value });
  });

  newPaymentRequest.onComplete = this.onReturnBack;
  // const checkoutResult = await this.callCheckoutFunction(newPaymentRequest);
  // console.log(checkoutResult);

  try {
  await this.callCheckoutFunction(newPaymentRequest);

} catch (err) {
  console.error("Checkout failed or cancelled:", err.message);
  sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'PAYMENT_CANCEL');
  return "Payment failed or cancel"
}
  return "Success"; 
}

async callCheckoutFunction(paymentRequest) {
  console.log('Calling webCheckout');

  return new Promise((resolve, reject) => {
    let settled = false;
    this.checkoutReject = reject; // So onReturnBack can call this

    // Fallback timeout in case no callback is fired
    const timeout = setTimeout(() => {
      if (!settled) {
        settled = true;
        reject(new Error("Checkout timed out or was cancelled silently."));
      }
    }, 60000); // 60 seconds

    try {
      window.webpayCheckout(paymentRequest, (success) => {
        if (settled) return;

        console.log('Callback triggered with:', success);
        settled = true;
        clearTimeout(timeout);

        if (success) {
          resolve("Payment successful");
        } else {
          reject(new Error("Payment failed"));
        }
      });
    } catch (err) {
      if (!settled) {
        settled = true;
        clearTimeout(timeout);
        reject(new Error("webpayCheckout threw an error: " + err.message));
      }
    }
    console.log('After webpayCheckout call');
    hideProgressBar();
  });
}

  confirmData = async () => {
    const { paymentdata, paramsData} = this.props;
    let newData= {...paymentdata};
    const fullName = paymentdata.FirstName + " " + paymentdata.LastName

    if (newData.Email===undefined){
      newData.Email = '';
      this.props.setPaymentField({field:"Email", value: ''});
    }

    if (newData.LandId===undefined){
      newData.LandId = this.props.LandId;
    }

    const RequestResponse = await createDNandRERequest(this.context.generalEndPoint, newData, paramsData);

    const billingResults = RequestResponse.data["billingResults"];
    const billingStatus = RequestResponse.data["billingStatus"];
    let receiptId = 0;

    if (billingStatus === "OK") {
      if (billingResults !== undefined && billingResults != "null") {
        const billingResultsJSON = JSON.parse(billingResults);
        if (
          billingResultsJSON !== undefined &&
          billingResultsJSON[0] !== undefined &&
          billingResultsJSON[0].RECEIPT_ID !== undefined
        ) {
          receiptId = billingResultsJSON[0].RECEIPT_ID;
          sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'DN and RE created successfully');
        }
        this.props.updateStateParams(receiptId, () => {
          //before redux this.props.updateShowCase(this.props.nextStage);
          this.props.setShow(this.props.nextStage);
      });
      }
      //updateShowCase(nextStage);
    } else {
      let msg = "";
      msg = getErrorMessages("DNandReNotCreated");
      sendLog(this.context.paymentEndPoint, this.props.LandId, paymentdata.IDType, paymentdata.IDNumber, fullName, 'DN and RE not created');
      /* before redux
      this.props.updateErrorMessage(
        msg["Title"],
        msg["Message"],
        msg["LinkTo"],
        msg["LinkTitle"],
        msg["LinkClass"]
      );
      this.props.updateShowCase(this.props.errorStage);
      */

      this.props.setErrorState({
        errorTitle: msg["Title"],
        errorMessage: msg["Message"],
        errorLinkTo: msg["LinkTo"],
        errorLinkTitle: msg["LinkTitle"],
        errorLinkClassName: msg["LinkClass"],
        prevStage: msg["prevStage"],
      });
      if (this.props.paymentdata) {
        localStorage.setItem('paymentDataBackup', JSON.stringify(this.props.paymentdata));
        localStorage.setItem('returningFromError', 'true');
      }
      this.props.showError();
      this.props.setShow(this.props.errorStage);
    }
  };

  /*validateFields = () => {
    var elements = document.getElementsByClassName("InputWrapperDiv");
    for (var i = 0; i < elements.length; i++) {
      console.log("input: " + elements[i].children[0].value.length);

      if (elements[i].className.indexOf("tooltip") < 0) {
        elements[i].className = elements[i].className + " tooltip";
      }
    }
  };*/


  doPreSubmit = (e) => {

    let isAnonymous = this.props.OwnerId === '';

    if(!isAnonymous)
    {
      this.props.data.BillingDetails = 'EMPTY';

      console.log('doPreSubmit not anonymous this.state.data.BillingDetails ' + this.props.data.BillingDetails);
    }
    this.handleSubmit(e);
  };

  /*changeMobileNumber = (value) => {
    // alert(value);
    //console.log(e.target.value);
    let { data } = this.state;
    if (value !== undefined) {
      data.PayerPhoneNumber = value;
    } else {
      data.PayerPhoneNumber = "+";
    }

    this.setState({ data: data });
    //alert("mobiLe=" + this.state.data.mobile + "=");
  };
  onClickPhoneInput = (value) => {
    let mobileInput = document.getElementById("mobileInput");
    if (mobileInput !== undefined) {
      mobileInput.value = "+";
    }
  };

  handleDatePickerChange = date => {
    console.log("handleDatePickerChange");
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        CardExpiryDate: date,
      },
    }), () => {
      console.log(this.state.data.CardExpiryDate);
      //this.validateField('CardExpiryDate', date);
    });
  };
  // Handler functions to update state
  handleMonthChange = (event) => {
    const selectedMonth = event.target.value;
    const updatedCardExpiryDate = `${selectedMonth}/${this.state.selectedYear}`;

    this.setState({
      selectedMonth,
      data: { ...this.state.data, CardExpiryDate: updatedCardExpiryDate },
    });
  };
  handleYearChange = (event) => {
    const selectedYear = event.target.value;
    const updatedCardExpiryDate = `${this.state.selectedMonth}/${selectedYear}`;

    this.setState({
      selectedYear,
      data: { ...this.state.data, CardExpiryDate: updatedCardExpiryDate },
    });
  };
  */

  render() {
    const { paymentdata} = this.props;
    let errorMessage = this.props.errorMessage;
    let feeValueRenderString = paymentdata.feeValue.toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    let isAnonymous = this.props.OwnerId === "";
    let deliveryType = "Digital print";
    return (
      <React.Fragment>
        <MobileView>
          <div className="text-black">
            <div className="h6 PaymentTitle">
            <br/>Please enter your card details.
            </div>
          </div>
          <div className="SearchLandResults">
            {/* <div className="ResultRow">
                <div className="ColumnTitle">Property No.</div>
                <div className="SearchResultItem">
                {propertyName.length > 11 ? (
                  <ShortValueField
                    shortValue={propertyNameShort}
                    fullValue={propertyName}
                  />
                ) : (
                  <div>{propertyName}</div>
                )}
                </div>
              </div> */}
            <div className="ResultRow">
              <div className="ColumnTitle1">Delivery</div>
              <div className="SearchResultItem1">{deliveryType}</div>
            </div>
            <div className="ResultRow">
              <div className="ColumnTitle1">Payment</div>
              <div className="SearchResultItem1">{paymentdata.paymentmethod}</div>
            </div>
            <div className="ResultRow">
              <div className="ColumnTitle1">Cost (₦)</div>
              <div className="SearchResultItem1">{feeValueRenderString}</div>
            </div>
          </div>
        </MobileView>
        <BrowserView>
          <div className="text-black">
            <div className="h6 PaymentTitle">
              Please enter your card details.
            </div>
          </div>
          <div className="SearchLandResults AdditionPayment">
            <div id="SearchResultTitles">
              <div className="ColumnTitle1">Delivery</div>
              <div className="ColumnTitle1">Payment</div>
              <div className="ColumnTitle1">Cost (₦)</div>
            </div>
            <div id="SearchResultData">
              <div className="SearchResultItem1">Digital print</div>
              <div className="SearchResultItem1">{paymentdata.paymentmethod}</div>
              <div className="SearchResultItem1">{feeValueRenderString}</div>
            </div>
          </div>
        </BrowserView>
        <div id="LandPaymentDataForm">
          <form onSubmit={this.handleSubmit} className="LandRegisterForm">
            <div id="ErrorMessageDiv" className="ErrorMessageDiv">
              <span className="ErrorMessageExclamationMark">!&nbsp;</span>
              {errorMessage}
            </div>
            <div className="row">
              <div className="dropdownSearchDiv">
                <select
                  value={this.props.selectedType}
                  onChange={(e) =>
                    //before redux this.setState({ selectedType: e.target.value })
                    this.props.setSelectedType(e.target.value)
                  }
                  className="custom-placeholder"
                  style={{ width: "100%" }}>
                  <option value="" hidden>
                    ID Type
                  </option>
                  {this.props.IdTypesOptions.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row">
              {this.renderInput(
                "IDNumber",
                "",
                "colTextbox",
                "text",
                "ID number",
                "",
                "",
                ""
              )}
            </div>
            <div className="row">
              {this.renderInput(
                "FirstName",
                "",
                "colTextbox",
                "text",
                "First Name",
                "",
                "",
                ""
              )}
            </div>
            <div className="row">
              {this.renderInput(
                "LastName",
                "",
                "colTextbox",
                "text",
                "Last Name",
                "",
                "",
                ""
              )}
            </div>
            <div className="row">
              {this.renderInput(
                "Email",
                "",
                "colTextbox",
                "text",
                "Email",
                "",
                "",
                ""
              )}
            </div>
            {/*
            <div  className="row">
                <div className = "dropdownSearchDiv">
                <select value={this.state.selectedValue} 
                        onChange={(e) => {
                          e.persist(); 
                          this.setState((prevState) =>({ selectedValue: e.target?.value||'' , data: { ...prevState.data, CardType: e.target?.value ||'' }}));
                        }}
                        className="custom-placeholder" 
                        style={{ width: '100%' }}>
                    <option value="" hidden>Card Type</option>
                    {this.state.CardTypesOptions.map ((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))
                    }
                  </select>
                </div>
                  </div>
              <div className="row">
              {
                this.renderInput(
                  "CardNumber",
                  "",
                  "colTextbox",
                  "text",
                  "Card number",
                  "",
                  "",
                  "") 
              }   
            </div>
            <div>
              <CreditCardDatePicker
                selectedMonth={selectedMonth}
                selectedYear={selectedYear}
                onMonthChange={this.handleMonthChange}
                onYearChange={this.handleYearChange}
              />
            </div>
            <div className="row">
              {
                this.renderInput(
                  "SecurityNumber",
                  "",
                  "colTextbox",
                  "text",
                  "Security number",
                  "",
                  "",
                  "") 
              }   
            </div>*/}

            {/*<div className="PhoneAndPinCode">
              <div className="PhoneNumberWrapper">
                <div className="InputWrapperDiv" id="mobileInputDiv">
                  <PhoneInput
                    className="col-15"
                    placeholder="Mobile"
                    international
                    id="mobileInput"
                    // defaultCountry="ZM"
                    value={data.PayerPhoneNumber}
                    onChange={this.changeMobileNumber}
                    onClick={this.onClickPhoneInput}
                  />
                </div>
              </div>
              <div className="PinCodeNumberWrapper">
              {
                  this.renderPasswordNumericInput(
                  "PinCode",
                  "",
                  "colTextbox",
                  "password",
                  "Pin code",
                  "",
                  "",
                  "",
                  "",
                  "[0-9]*",
                  "numeric"
                )}
              </div>
                  </div>*/}

            {/*<div className="row">
              {
              isAnonymous ?
                this.renderInput(
                "BillingDetails",
                "",
                "colTextbox",
                "text",
                "Billing details",
                "",
                "",
                ""
              ) : 
                (<div></div>)
              }
            </div> */}
            <div id="PaymentButttonsDivLandRegPay">
              <button
                className="btnCancel"
                type="Button"
                onClick={this.backStage}>
                Back
              </button>

              {/*<button className="btnConfirmPay" type="button" onClick={this.doPreSubmit} autoFocus>*/}
              <button
                className="btnConfirm"
                type="button"
                onClick={this.executePayment}>
                Pay now
              </button>
            </div>
          </form>
        </div>
      </React.Fragment>
    );
  }
}


// Redux state → props
const mapStateToProps = (state) => {
  //const landSearch = state.landSearch;
  //onst payment = state.payment;

    const landSearch = selectLandSearch(state) || {};
    const payment = selectPayment(state) || {};

  return {
    // from landSearch slice
    data: landSearch.data,
    feeValue: landSearch.searchResult?.feeValue,
    WebUserId: landSearch.webUserId,
    OwnerId: landSearch.ownerId,
    propertyNumber: landSearch.searchResult?.propertyNumber,
    ModuleName: landSearch.ModuleName,
    show: landSearch.show,

     // from payment slice
    UsersList: payment.UsersList,
    isLoadingUsers: payment.isLoadingUsers,
    prevStage: payment.prevStage,
    paymentdata: payment.data,
    IdTypesOptions: payment.IdTypesOptions,
    selectedType: payment.selectedType,
    paramsData: payment.paramsData,
    paymentRequest: payment.paymentRequest
  };
};

// Dispatch → props
const mapDispatchToProps = {
  populateFromSearch,
  fetchUsersList,
  fetchIdTypeOptions,
  setShow,
  setSelectedType,
  setPaymentField,
  setPrevStage,
  setNextStage,
  clearAllErrors,
  setErrorState,
  setPaymentRequestField,
  showError,
  returnFromError
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentDetailsForm);
//export default PaymentDetailsForm;
